import { Flex } from '@components';
import { Box, Paper, styled } from '@mui/material';

export const Root = styled(Box)(({ theme }) => ({
  display: 'flex',
  flex: 1,
  width: '100%',
  alignItems: 'flex-start',
  [theme.breakpoints.down('md')]: {
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export const Container = styled(Paper)(({ theme }) => ({
  margin: '0 15%',
  padding: theme.spacing(18, 19, 19, 19),
  boxShadow: '0px 24px 34px rgba(0, 0, 0, 0.09)',
  borderRadius: theme.spacing(11),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(18, 17, 19, 17),
    margin: '0 10%',
  },
}));

export const ContentContainer = styled(Flex)(({ theme }) => ({
  flexDirection: 'column',
  textAlign: 'center',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(10),
}));
